export default (state = { options: [], runtimeInfo: {} }, action) => {
  if (action.type === "DYNAMIC_OPTIONS_LOADED") {
    return {
      ...state,
      options: action.dynamicOptions.options,
      runtimeInfo: action.dynamicOptions,
    };
  }

  return state;
};
